module.exports = __webpack_public_path__ + "static/media/marker_airqast.328309d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/marker_airqast.svg
// module id = 1457
// module chunks = 0